import { render, staticRenderFns } from "./crgl.vue?vue&type=template&id=6906d281&scoped=true&"
import script from "./crgl.vue?vue&type=script&lang=js&"
export * from "./crgl.vue?vue&type=script&lang=js&"
import style0 from "./crgl.vue?vue&type=style&index=0&id=6906d281&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6906d281",
  null
  
)

export default component.exports